import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.18 13.3H5a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.44.29-.72a1 1 0 0 1 .71-.29h11.18l-4.9-4.9a1 1 0 0 1-.29-.7 1 1 0 0 1 .31-.7q.3-.27.7-.28t.7.28l6.6 6.6q.16.15.22.33a1 1 0 0 1 0 .75 1 1 0 0 1-.21.32l-6.6 6.6a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28 1 1 0 0 1-.3-.71q0-.42.3-.71z" />
  </svg>
)
export default SvgArrowRight
